import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 8v8H8V8h8m2-2H6v12h12V6z"
}), 'StopOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StopOutlined.js
// module id = 6504
// module chunks = 2